export const getRealScreenWidth = () => {
    if (Math.abs(window.orientation) === 90)
        return Math.max(screen.width, screen.height);
    return screen.width;
};
